import { KINDS } from "@/components/dialogs/kinds";
import { cn } from "@/lib/utils";

// The tinted top of a confirm / notice popup: a round icon, then the title and the short explanation.
export function DialogHeaderBand({ kind = "info", icon, children }) {
  const k = KINDS[kind] || KINDS.info;
  const Icon = icon || k.icon;
  return (
    <div className={cn("flex items-start gap-3 px-6 py-5", k.band)}>
      <span className={cn("mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full", k.chip)} aria-hidden="true">
        <Icon className="h-5 w-5" />
      </span>
      <div className="min-w-0 flex-1 space-y-1 pr-6">{children}</div>
    </div>
  );
}
